module.exports = __webpack_public_path__ + "img/xhc.b2c576c3.png";